import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import ModalBasic from "../components/ModalBasic";
import ModalLoading from "../components/ModalLoading";
import Toast from "../components/Toast";
import { HEADER } from "../utils/Utils";

export default function ConfirmOutlet() {
   const [modalShow, setModalShow] = useState(false);
   const [modalMessage, setModalMessage] = useState(false);
   const [dataOutlet, setDataOutlet] = useState({});
   const [outletID, setOutletID] = useState("");
   const [showModalLoading, setShowModalLoading] = useState(false);
   const [message, setMessage] = useState("");
   const navigate = useNavigate();

   async function getDetailOutlet() {
      setShowModalLoading(true);
      // Voucher Active
      //  DETAIL OUTLET
      await fetch(
         `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini?outlet_kartini_code=${outletID}`,
         {
            method: "GET", // or 'PUT'
            headers: HEADER,
         }
      )
         .then((res) => res.json())
         .then((data) => {
            if (data.data.length <= 0 || data.data.length > 1) {
               setMessage("Outlet not available, check the outlet code...");
               setModalMessage(true);
               setDataOutlet({});
            } else {
               if (data.data[0].status === "active") {
                  setMessage("Outlets have been registered...");
                  setModalMessage(true);
               } else {
                  setDataOutlet(data.data[0]);
                  setModalShow(true);
               }
            }
         })
         .catch((error) => {
            console.error("Error:", error);
            setDataOutlet({});
            setMessage("Outlet not available, check the outlet code...");
            setModalMessage(true);
         });
      setShowModalLoading(false);
   }

   return (
      <>
         <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
         />
         <div className="m-1.5">
            {/* Start */}
            <ModalBasic
               id="detail-outlet-modal"
               modalOpen={modalShow}
               setModalOpen={setModalShow}
               title="Outlet Detail"
               enClose={true}
            >
               <div className="px-5 pt-4 pb-1">
                  <div className="space-y-3">
                     <div className="text-sm">
                        <div className="font-medium text-gray-800 mb-1">
                           Outlet Name
                        </div>
                        <p className="text-gray-500">
                           {dataOutlet.outlet_kartini_name ?? "-"}
                        </p>
                     </div>
                     <div className="text-sm">
                        <div className="font-medium text-gray-800 mb-1">
                           Outlet ID
                        </div>
                        <p className="text-gray-500">
                           {dataOutlet.outlet_kartini_id ?? "-"}
                        </p>
                     </div>
                     <div className="text-sm">
                        <div className="font-medium text-gray-800 mb-1">
                           Outlet Address
                        </div>
                        <p className="text-gray-500">
                           {dataOutlet.address ?? "-"}
                        </p>
                     </div>
                  </div>
               </div>
               {/* Modal footer */}
               <div className="px-5 py-4">
                  <div className="flex flex-wrap justify-end space-x-2">
                     <button
                        className="btn-sm border-gray-200 hover:border-gray-300 text-gray-600"
                        onClick={(e) => {
                           e.stopPropagation();
                           setModalShow(false);
                        }}
                     >
                        Close
                     </button>
                     <button
                        className="btn-sm bg-[#4CA6F8] text-white"
                        onClick={() =>
                           navigate("/register", {
                              state: {
                                 dataOutlet,
                              },
                           })
                        }
                     >
                        Confirm Register
                     </button>
                  </div>
               </div>
            </ModalBasic>
            {/* End */}
         </div>
         <div className="relative space-y-10">
            <Header title="Validate Outlet" />
            <div className="px-4 py-8 bg-white">
               <h1 className="text-3xl text-gray-800 font-bold mb-6">
                  Validate Outlet
               </h1>
               {/* Form */}
               <form>
                  <div className="space-y-4">
                     <div>
                        <input
                           id="outlet_id"
                           placeholder="Outlet Code"
                           className="form-input w-full h-14"
                           type="text"
                           onChange={(e) => setOutletID(e.target.value)}
                        />
                     </div>
                  </div>
                  <div className="flex flex-col mt-6 space-y-2">
                     <button
                        className="btn-lg bg-[#CCCCCC] text-[#7D7C7C]"
                        aria-controls="basic-modal"
                        onClick={(e) => {
                           e.preventDefault();
                           e.stopPropagation();
                           getDetailOutlet();
                        }}
                     >
                        CONFIRM
                     </button>
                  </div>
               </form>
               <Toast
                  className="mt-4"
                  type="warning"
                  open={modalMessage}
                  setOpen={setModalMessage}
               >
                  {message}
               </Toast>
            </div>
         </div>
      </>
   );
}
